export default "__VITE_ASSET__ZiOseTX5__"